import { render, staticRenderFns } from "./Microphone.vue?vue&type=template&id=3ceef37a&"
import script from "./Microphone.vue?vue&type=script&lang=js&"
export * from "./Microphone.vue?vue&type=script&lang=js&"
import style0 from "./Microphone.vue?vue&type=style&index=0&id=3ceef37a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports